import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import jQuery from 'jquery';
import {SoftSkill} from '../../shared/soft-skill';

@Component({
    selector: 'occupational-profile-soft-skill-item',
    templateUrl: './occupational-profile-soft-skill-item.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OccupationalProfileSoftSkillItemComponent {

    @Input()
    public index!: number;
    @Input()
    public softSkill!: SoftSkill;
    public softSkillSelected = false;

    clickAccordionHeader(softSkill: SoftSkill, event: any): void {
        this.toggleAccordion(event.target);

        this.softSkillSelected = !this.softSkillSelected;
    }

    toggleAccordion(element: any): void {
        (jQuery||$)(element).closest('.c-accordion__header').siblings('.c-accordion__content').slideToggle(150);

        const isAriaExp = (jQuery||$)(element).find('.c-accordion__button').attr('aria-expanded');
        const newAriaExp = (isAriaExp === "false") ? "true" : "false";
        (jQuery||$)(element).find('.c-accordion__button').attr('aria-expanded', newAriaExp);

        const isAriaHidden  = (jQuery||$)(element).closest('.c-accordion__header').siblings('.c-accordion__content').attr('aria-hidden');
        const newAriaHidden = (isAriaHidden === "true") ? "false" : "true";
        (jQuery||$)(element).closest('.c-accordion__header').siblings('.c-accordion__content').attr('aria-hidden', newAriaHidden);
    }

    hasDescription(): boolean {
        return !!(this.softSkill.description && this.softSkill.description.nl);
    }

}
